module.exports = __webpack_public_path__ + "img/sv.8972dfdb.svg";